<div>
    <a
        mat-list-item
        (click)="onItemSelected(item)"
        [ngClass]="{
            active: item?.state ? router.isActive(item?.state, true) : false,
            expanded: expanded
        }"
    >
        <mat-icon *ngIf="item?.icon">{{ item?.icon }}</mat-icon>

        <span class="px-2 fs-sm-14" (click)="routing(item)">
            {{ lang == "ar" ? item?.name_ar : item?.name }}
        </span>

        <!-- tags level1 -->
        <span
            [ngStyle]="{
                color: item?.label_text_color
                    ? item?.label_text_color
                    : '#248A3D',
                background: item?.label_text_backround_color
                    ? item?.label_text_backround_color
                    : '#DEEEE2'
            }"
            *ngIf="item.label_text_en || item.label_text_ar"
            class="card-menu-label fs-12 fs-sm-10">
            {{ lang === 'en' ? item.label_text_en : item.label_text_ar }}
        </span>
        
        <!-- tags level3 -->
        <span
            [ngStyle]="{
                color: item?.subCategory_label_text_color
                    ? item?.subCategory_label_text_color
                    : '#248A3D',
                background: item?.subCategory_label_text_backround_color
                    ? item?.subCategory_label_text_backround_color
                    : '#DEEEE2'
            }"
            *ngIf="item?.subCategory_label_text_en || 
                item?.subCategory_label_text_ar"
            class="card-menu-label fs-12 fs-sm-10">
            {{ lang === 'en' ? item?.subCategory_label_text_en : item?.subCategory_label_text_ar }}
        </span>

        <span fxFlex *ngIf="item?.level2?.length">
            <span fxFlex></span>
            <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
                expand_more
            </mat-icon>
        </span>
        <span fxFlex *ngIf="item?.level3 && item?.level3?.length">
            <span fxFlex></span>
            <mat-icon
                [@indicatorRotate]="expandedLv2 ? 'expanded' : 'collapsed'"
            >
                expand_more
            </mat-icon>
        </span>
    </a>
    <div *ngIf="expandedLv2" class="responsive-menu-side">
        <embryo-SidebarMenu
            *ngFor="let sub_category of item?.level3"
            [item]="sub_category"
            [depth]="depth + 1"
            [lang]="lang"
        >
        </embryo-SidebarMenu>
    </div>
    <div *ngIf="expanded" class="responsive-menu-side">
        <embryo-SidebarMenu
            *ngFor="let group of item?.level2"
            [item]="group"
            [depth]="depth + 1"
            [lang]="lang"
            [categoryId]="getCategoryId(item)"
        >
        </embryo-SidebarMenu>
    </div>
</div>
